import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useRemoveCoverLesson = ({ onSuccess }: { onSuccess: () => void }) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: { id: string }) =>
      httpService.panel.panelLessonsCoverDestroy(data.id),
    onSuccess
  })

export default useRemoveCoverLesson
